<template>
  <Transition name="search-toast">
    <div
      class="search-toast"
      v-if="visible"
    >
      <Icon
        class="search-toast__icon"
        name="right-l"
      />
      AI has found the products you may need!
    </div>
  </Transition>
</template>

<script setup>
import { Icon } from '@/components/Icon'

const props = defineProps({
  show: Boolean
})

const visible = ref(props.show)

watch(() => props.show, (val) => {
  if (val) {
    visible.value = true
    setTimeout(() => {
      visible.value = false
    }, 3000)
  }
})
</script>

<style lang="less">
.search-toast {
  z-index: 99;
  position: fixed;
  left: 50%;
  bottom: 40px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 12px 16px;
  background: #1153D6;
  color: #FFFFFF;
  border-radius: 24px;
  font-family: mon-500;
  font-size: 12px;
  text-align: center;
  width: 80%;

  @media (min-width: 1024px) {
    gap: 4px;
    padding: 14px 20px 14px 14px;
    width: auto;
  }

  &__icon {
    flex-shrink: 0;
    font-size: 16px;
  }
}

.search-toast-enter-active {
  transition: all 0.3s ease-out;
}

.search-toast-leave-active {
  transition: all 0.3s ease-in;
}

.search-toast-enter-from,
.search-toast-leave-to {
  transform: translate(-50%, 100%);
  opacity: 0;
}
</style>
